// This file was generated on Fri Jul  1 17:05:58 PDT 2022
export const appVersion = '8.6.59';
